<template>
  <comment
    v-for="comment in comments"
    :comment="comment"
    :collection="
      comment.children && comment.children.length > 2
        ? comment.children.slice(-2)
        : comment.children
    "
    :key="comment.id"
  ></comment>
</template>

<script>
import { events } from "../../events";
export default {
  props: ["comments", "collection"],
  mounted() {},
};
</script>

<style></style>
